/**
 * Hides popover with the id specified.
 */
export function hidePopoverById(id: string) {
  document.getElementById(id)?.hidePopover();
}
